import { apiLoyaltyLandingInfo, apiLoyaltyRewards } from '@/resource'

export default {
  async actionGetLoyaltyInfo({ commit, state }) {
    apiLoyaltyLandingInfo().then(res => {
      let resp = res.data.data && res.data.data.loyaltyLandingInfo ? res.data.data.loyaltyLandingInfo : res.data.data
      commit('setLoyaltyInfo', resp)
      if (res.data.data) {
        commit('setShowLoyalty', res.data.data.isEnabled)
      }
    })
  },
  async actionGetAvailableRewards({ commit, state }) {
    apiLoyaltyRewards().then(res => {
      let resp = res.data.data
      commit('setLoyaltyRewards', resp)
    })
  },
}
